export const PALETTES = {
    NONE: 'none',
    ACCENT: 'accent',
    MENTION: 'mention',
    SUCCESS: 'success',
    WARNING: 'warning',
    DANGER: 'danger',
    LIGHT_PRIMARY: 'LIGHT_PRIMARY',
    DARK_PRIMARY: 'DARK_PRIMARY',
    TRANSPARENT: 'TRANSPARENT',
};
